import { Component, OnInit } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Event as RouterEvent,
  NavigationCancel,
  NavigationError
} from "@angular/router";
import { Location } from "@angular/common";
import { NgZone, Renderer, ElementRef, ViewChild } from "@angular/core";
import { Title, Meta } from "@angular/platform-browser";
import { PromosService } from "app/services/promos/promos.service";
import { OrderService } from "./services/order/order.service";
import { ItemDescriptionsService } from "./services/item-descriptions/item-descriptions.service";
import { ModifiersService } from "./services/modifiers/modifiers.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  public isHome: boolean;
  public bagIsActive: boolean = false;
  public loading: boolean = true;
  public fullWidth: boolean = false;
  public noPromos: boolean = true;
  public onlineOrderingModalIsActive = false;

  @ViewChild("loadingElement") loadingElement: ElementRef;

  constructor(
    private _router: Router,
    private _activeRoute: ActivatedRoute,
    private ngZone: NgZone,
    private renderer: Renderer,
    private _orderService: OrderService,
    private _itemDescriptionService: ItemDescriptionsService,
    private _modifiersService: ModifiersService,
    title: Title,
    private meta: Meta,
    private _promoService: PromosService
  ) {
    title.setTitle(
      "Rodrigo’s Mexican Grill | Authentic Mexican Food in Santa Ana, Orange and more"
    );
  }

  ngOnInit() {
    this._promoService.getPromos().then(result => {
      let promos: any = result;
      if (promos.length <= 0) {
        this.noPromos = true;
      }
    });

    this.routeChange();
    this.ngZone.runOutsideAngular(() => {
      this.renderer.setElementStyle(
        this.loadingElement.nativeElement,
        "opacity",
        "1"
      );
    });
    setTimeout(() => {
      this._hideLoader();
      this.loading = false;
    }, 2000);
    
    // this.meta.addTags([
    //   { name: "author", content: "Rodrigos.com" },
    //   {
    //     name: "keywords",
    //     content:
    //       "Mexican food, Tustin, Temecula, Corona, Taco Tuesday, brunch, happy hour, margaritas, Mexican restaurant, dine-in, takeout"
    //   },
    //   {
    //     name: "description",
    //     content:
    //       "Rodrigo’s Mexican Grill serves the best Mexican food in Tustin, Temecula, Corona, Santa Ana, Orange & more. Join us for Taco Tuesday, brunch, happy hour, and margaritas."
    //   }
    // ]);
  }

  private _hideLoader(): void {
    this.ngZone.runOutsideAngular(() => {
      this.renderer.setElementStyle(
        this.loadingElement.nativeElement,
        "opacity",
        "0"
      );
    });
  }

  routeChange() {
    let url: string;

    this._router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);

        let url = this._router.url;

        if (url === "/" || url === "" || url == "/checkout") {
          this.isHome = true;
        } else {
          this.isHome = false;
        }

        if (
          url.includes("event-reservations") ||
          url.includes("checkout") ||
          url.includes("promos") ||
          url.includes("jobs") ||
          url.includes("contact") ||
          url.includes("rodrigos-rewards") ||
          url.includes("about") ||
          url.includes("login") ||
          url.includes("/admin") ||
          url.includes("/legal") ||
          url.includes("/hours-locations") ||
          url.includes("/mobile-app") ||
          url.includes("/baja-fiesta") ||
          url.includes("/taco-tuesdays") ||
          url.includes("/52nd-anniversary") ||
          url.includes("/fiesta-de-las-madres") ||
          url.includes("/dads-and-grads") ||
          url.includes("/kids-eat-free-mondays") ||
          url.includes("/hispanic-heritage-month") ||
          url.includes("/fundraising-program") ||
          url.includes("/star-achievers") ||
          url.includes("/national-quesadilla-day") ||
          url.includes("/national-coffee-day") ||
          url.includes("/national-taco-day") ||
          url.includes("/dia-de-los-muertos") ||
          url.includes("/halloween-week") ||
          url.includes("/holiday-season") ||
          url.includes("/margarita-flights") ||
          // url.includes("/jobs/anaheim-hills") ||
          url.includes("/reservations") ||
          url.includes("/holiday-bonus-card") ||
          url.includes("/restaurant-week") ||
          url === "/"
        ) {
          this.fullWidth = true;
        } else {
          this.fullWidth = false;
        }
      }
    });
  }

  updateBagState(event) {
    this.bagIsActive = event.bagIsActive;
  }

  toggleOnlineOrderingModal(event) {
    this.onlineOrderingModalIsActive = event.open;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts